import React, { useState } from 'react';
import styles from './NewUser.module.scss';
import api from '../../services/api.tsx';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

const NewUser: React.FC = () => {
  const [email, setEmail] = useState('');
  const [usuario, setUsuario] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [erroDeSenha, setErroDeSenha] = useState('');

   const handleConfirmarSenha = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
        if (password !== e.target.value) {
            setErroDeSenha('As senhas não coincidem');
        } else {
            setErroDeSenha('');
        }
    };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      const response = await api.post('/auth/register', { email: email, senha: password, nome: usuario, isAdmin: false });
      console.log('Sucesso:', response.data);
      navigate('/Home');
    } catch (error) {
      console.error('Erro ao registrar:', error);
      alert("Erro ao criar login");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.logo}>
          <span>Sergi</span><span>panidade</span>
        </div>

        <h2 className={styles.title}>Criar nova conta</h2>
        <p className={styles.subtitle}>Preencha os campos abaixo para criar sua conta</p>

        <form onSubmit={handleLogin}>
          <div className={styles.formGroup}>
            <label>E-mail</label>
            <div className={styles.inputWrapper}>
              <EmailOutlinedIcon className={styles.icon} sx={{ fontSize: 20 }} />
              <input 
                type="text" 
                className={styles.input} 
                placeholder="Novo Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

           
          <div className={styles.formGroup}>
            <label>Usuário</label>
            <div className={styles.inputWrapper}>
              <EmailOutlinedIcon className={styles.icon} sx={{ fontSize: 20 }} />
              <input 
                type="text" 
                className={styles.input} 
                placeholder="Usuário"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <div className={styles.labelRow}>
              <label>Senha</label>
            </div>
            <div className={styles.inputWrapper}>
              <LockOutlinedIcon className={styles.icon} sx={{ fontSize: 20 }} />
              <input 
                type="password" 
                className={styles.input} 
                placeholder="Nova Senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.formGroup}>
            <div className={styles.labelRow}>
              <label>Confirmar Senha</label>
                {erroDeSenha && <span className={styles.error}>{erroDeSenha}</span>}
            </div>
            <div className={styles.inputWrapper}>
              <LockOutlinedIcon className={styles.icon} sx={{ fontSize: 20 }} />
              <input 
                type="password" 
                className={styles.input} 
                placeholder="Confirmar Senha"
                value={confirmarSenha}
                onChange={(e) => {setConfirmarSenha(e.target.value); handleConfirmarSenha(e);}}
              />
            </div>
          </div>

          <button type="submit" className={styles.btnPrimary}>
            Criar conta
          </button>
        </form>

        <div className={styles.divider}>ou</div>

        <button className={styles.btnOutline} onClick={() => navigate('/')}>
          Voltar
        </button>
      </div>
    </div>
  );
};

export default NewUser;